import ContentCard from '@/components/app/cards/ContentCard';
import { Pack, ProgramOrGuideItem } from '@/components/app/cards/PacksList/types';

import { MAX_RECOMMENDATIONS } from '../constants';
import { RecommendationsGrid, StyledContentCard } from '../styles';
import { buildSearchQuery } from '../utils';

interface RecommendationsListProps {
	recommendationPack: Pack;
	onContentClick: (contentId?: string) => void;
}

export default function RecommendationsList({
	recommendationPack,
	onContentClick,
}: RecommendationsListProps) {
	return (
		<RecommendationsGrid>
			{recommendationPack.items.slice(0, MAX_RECOMMENDATIONS).map((item, idx) => {
				const programOrGuideItem = item as ProgramOrGuideItem;
				return (
					<StyledContentCard key={programOrGuideItem.guide_id ?? programOrGuideItem.program_id}>
						<ContentCard
							pack={recommendationPack}
							card={programOrGuideItem}
							onClick={onContentClick}
							searchQuery={buildSearchQuery(idx)}
						/>
					</StyledContentCard>
				);
			})}
		</RecommendationsGrid>
	);
}
